<template>
  <div class="mailDetail">
    <div class="back" >
      <span @click="back">
        <i class="el-icon-arrow-left"></i>返回
      </span>
    </div>
    <div class="mailDetailConter">
      <div class="mailtitle">
        <span class="titleName">营销任务:{{formData.name}}</span>
        <span class="titleType">-{{formData.stateText}}</span>
        <div class="rightBtn" v-if="formData.state==10">
          <el-button @click="editor"  type="primary">编辑</el-button>
          <el-button @click="copy"   v-no-more-click >复制</el-button>
        </div>
      </div>

      <el-row>
        <el-col :span="14" class="previewMailssss">
          <previewMail :formData="formData" :tempUrlShow="tempUrlShow" :attachmentVos="attachmentVos"/>
        </el-col>
        <el-col :span="10"  >
          <previewDetail :formData="formData" :signature="signature" :filterGroupArr="filterGroupArr"/>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import previewDetail from "@/components/intellect-marketing/mailDetail/previewDetail"
import previewMail from "@/components/intellect-marketing/mailDetail/previewMail"
import {findById,findFilterConditions,copyById} from "@/utils/api/edmSubject"

export default {
  components:{
    previewDetail,previewMail
  },
  data(){
    return{
      formData:{},
      signature:'',
      filterGroupArr:[],
      attachmentVos:[],
      tempUrlShow:true
    }
  },
  created(){
    this.getData()
    this.getfindFilterConditions()
  },
  methods:{
    // 获取数据
    async getData(){
      const params={
        id:this.$route.query.id
      }
      const res =await findById(params)
      this.formData=res.data
      this.attachmentVos=[]
      // this.attachmentVos.push(res.data.attachmentVos)
      // console.log(this.attachmentVos)
      if(res.data.attachmentVos!=[]&&res.data.attachmentVos!=null){
        this.attachmentVos=res.data.attachmentVos
        console.log(this.attachmentVos)
        // this.formData.hashcode=this.attachmentVos[0].hashCode
      }
      if(this.formData.signatureId!=null&&this.formData.signatureId!=''&&this.formData.signatureId!=0){
        this.signature=this.formData.signatureVo.content
      }else{
        this.signature=''
      }
    },
    // 过滤数据
    async getfindFilterConditions(){
      const params={
        curPage:1,
        pageSize:10,
        attribute:'',
        sortType:'',
        id:this.$route.query.id
      }
      const res=await findFilterConditions(params)
      this.filterGroupArr = [];
      let arr = res.data.filterConditions;
      Object.keys(arr).forEach( (key)=>{
        const tmpe = { key: "", val: "" };
        tmpe.key = key;
        tmpe.val = arr[key].join(",");
        this.filterGroupArr.push(tmpe);
        return this.filterGroupArr;
      });
      console.log(this.filterGroupArr)    
    },
    back(){
      // this.$router.back()
      this.$router.push({
          name: 'mail-list',
        });
    },
    // 编辑
    editor(){
      if(this.formData.sendType==3){
        this.$router.push({
          name: 'customer-mail',
          query: {  
            id: this.formData.id,
            type: this.formData.state, }
        });
      }else{
        this.$router.push({
          name: 'created-mail',
          query: {  
            id: this.formData.id,
            type: this.formData.state, }
        });
      }
      // this.$router.push({
      //   name: 'created-mail',
      //   query: {  
      //     id: this.formData.id,
      //     type: this.formData.state, }
      // });
    },
    // 复制
    async copy(){
      console.log('copy')
      const params={
        id:this.formData.id
      }
      const res = await copyById(params)
      if(res.rspResult.bizCode==200){
        this.$message.success(res.rspResult.message)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mailDetailConter{
  padding: 0 40px;
  .mailtitle{
    margin: 28px 0;
  .rightBtn{
    float: right;
    margin-top: -8px;
  }
.titleName{
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #066EB7;
    }
    .titleType{
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #16181A;
    }
  }
}
.back{
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 14px;
  color: #4F5D78;
  background: #F5F7FA;
  padding-bottom: 15px;
  padding-top: 5px;
  span{
    cursor: pointer;
  }
}
</style>